export const agentReducer = (state = {
    loading: false,
    agents: null,
    agentView: null,
    interviews: null,
    updatingDocuments: false,
    updatingCategory: false,
    notificationStatus: null,
    error: null
}, action) => {
    switch (action.type) {
        case "GET_AGENT_LIST_REQUEST":
            return {
                ...state,
                loading: true,
                error: null
            };

        case "GET_AGENT_LIST_SUCCESS":
            return {
                ...state,
                loading: false,
                agents: action.payload,
                error: null
            };

        case "GET_AGENT_LIST_FAILED":
            return {
                ...state,
                loading: false,
                agents: null,
                error: action.payload
            };

        case "GET_AGENT_LIST_VIEW_REQUEST":
            return {
                ...state,
                loading: true,
                agentView: null,
                error: null
            };

        case "GET_AGENT_LIST_VIEW_SUCCESS":
            return {
                ...state,
                loading: false,
                agentView: action.payload,
                error: null
            };

        case "GET_AGENT_LIST_VIEW_FAILED":
            return {
                ...state,
                loading: false,
                agentView: null,
                error: action.payload
            };

        case "UPDATE_STAFF_DOCUMENTS_REQUEST":
            return {
                ...state,
                updatingDocuments: true,
                error: null
            };

        case "UPDATE_STAFF_DOCUMENTS_SUCCESS":
            return {
                ...state,
                updatingDocuments: false,
                agentView: action.payload.data || action.payload,
                error: null
            };

        case "UPDATE_STAFF_DOCUMENTS_FAILED":
            return {
                ...state,
                updatingDocuments: false,
                error: action.payload
            };

        case "UPDATE_AGENT_CATEGORY_REQUEST":
            return {
                ...state,
                updatingCategory: true,
                error: null
            };

        case "UPDATE_AGENT_CATEGORY_SUCCESS":
            return {
                ...state,
                updatingCategory: false,
                agentView: action.payload.data || action.payload,
                error: null
            };

        case "UPDATE_AGENT_CATEGORY_FAILED":
            return {
                ...state,
                updatingCategory: false,
                error: action.payload
            };

        case "GET_INTERVIEW_LIST_REQUEST":
            return {
                ...state,
                loading: true,
                error: null
            };

        case "GET_INTERVIEW_LIST_SUCCESS":
            return {
                ...state,
                loading: false,
                interviews: action.payload,
                error: null
            };

        case "GET_INTERVIEW_LIST_FAILED":
            return {
                ...state,
                loading: false,
                interviews: null,
                error: action.payload
            };

        case "UPDATE_INTERVIEW_REQUEST":
            return {
                ...state,
                loading: true,
                error: null
            };

        case "UPDATE_INTERVIEW_SUCCESS":
            return {
                ...state,
                loading: false,
                interviews: action.payload.data || state.interviews,
                error: null
            };

        case "UPDATE_INTERVIEW_FAILED":
            return {
                ...state,
                loading: false,
                error: action.payload
            };

        case "SEND_AGENT_NOTIFICATION_REQUEST":
            return {
                ...state,
                loading: true,
                notificationStatus: null,
                error: null
            };

        case "SEND_AGENT_NOTIFICATION_SUCCESS":
            return {
                ...state,
                loading: false,
                notificationStatus: action.payload,
                error: null
            };

        case "SEND_AGENT_NOTIFICATION_FAILED":
            return {
                ...state,
                loading: false,
                notificationStatus: null,
                error: action.payload
            };

        default:
            return state;
    }
};
